import { AppConfig } from '@/utils/AppConfig';
import {
  DirectusFiles,
  FfbbsiteBlockButton,
  FfbbsiteBlockColumnsRows,
  FfbbsitePages,
  FfbbsiteSelfPromotion,
} from '../directus';
import { Button, CardInfo, PushCardBackground } from '@/components/types';
import getDirectusImageUrl from '../utils/image';

const pickRandomSelfPromotion = (
  allPromotions: FfbbsiteSelfPromotion[],
  toSkipPromotions: FfbbsiteSelfPromotion[],
): FfbbsiteSelfPromotion | null => {
  const difference = allPromotions.filter((x) => !toSkipPromotions.map((x) => x.id).includes(x.id));
  if (difference.length === 0) {
    return null;
  }
  const randomIndex = Math.floor(Math.random() * difference.length);
  return difference[randomIndex];
};

type CardsInfo = {
  cards: Array<CardInfo>;
  height: 'default' | 'small' | 'high';
};

export default function mapBlockColumnsToCardInfo(
  data: Array<FfbbsiteBlockColumnsRows> = [],
  promotions: Array<FfbbsiteSelfPromotion> = [],
): CardsInfo {
  if (!data) {
    return { cards: [], height: 'default' };
  }

  const pickedRandomPromotion: Array<FfbbsiteSelfPromotion> = [];
  let height = 'default' as 'default' | 'small' | 'high';

  const cards = data.map(({ background, title, headline, image, button, type, socials_items }) => {
    let permalink;
    let external = false;

    let url = 'page';
    const cardButton: Button = {};

    let blockButton = undefined;
    let directusImageId = image as string;

    if (button) {
      blockButton = button as FfbbsiteBlockButton;
      cardButton.buttonStyle = blockButton.color as Button['buttonStyle'];
      cardButton.buttonLabel = blockButton.label || '';
      external = blockButton.is_external || false;
    }

    if (type === 'self_promotion') {
      const randomSelfPromotion = pickRandomSelfPromotion(promotions, pickedRandomPromotion);
      height = 'small';

      if (randomSelfPromotion) {
        const bannerFull = randomSelfPromotion.banner_full as DirectusFiles;
        directusImageId = bannerFull.id;
        blockButton = randomSelfPromotion.target as FfbbsiteBlockButton;
        pickedRandomPromotion.push(randomSelfPromotion);
        title = '';
      }
    }

    if (blockButton) {
      external = blockButton.is_external || false;
      if (blockButton.external_url) {
        url = blockButton.external_url;
      }
      if (blockButton.page) {
        permalink = (blockButton.page as FfbbsitePages).permalink;
      }
    }

    return {
      background: (background ?? 'default') as PushCardBackground,
      title: title || '',
      description: headline || '',
      intro: headline || '',
      image: directusImageId ? getDirectusImageUrl(directusImageId, false, 1400, 0, undefined, 'avif') : '',
      imageAlt: title || '',
      callToActionUrl: {
        url,
        slug: permalink || '',
        external,
      },
      button: cardButton,
      socials_items: Array.isArray(socials_items) && socials_items.length > 0 ? socials_items : [],
    };
  });

  return {
    cards,
    height,
  };
}
